import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MonumentMegalithic1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MONUMENT_MEGALITHIC1;
}

export default MonumentMegalithic1PoiTileEntity;
